import React from 'react';
import ReactDOM from 'react-dom/client';
import {Amplify} from 'aws-amplify';
import awsConfig from './aws-exports';
import "./assets/styles/helper-style.css"
import "./assets/styles/dashboard.css"
import "./assets/scripts/utilities"
import App from "./app/App"

export const updatedAwsConfig = {
    ...awsConfig,
    oauth: {
        ...awsConfig.oauth,
        domain: "oauth2.sussd.ie",
    },
   // aws_appsync_graphqlEndpoint: window.location.hostname === 'localhost' ? 'http://localhost:20002/graphql' : awsConfig.aws_appsync_graphqlEndpoint,
}

Amplify.configure(updatedAwsConfig);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App/>
);

// If you want to start measuring performance in your app, pass a function

// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
